import React, { createContext, useReducer, useMemo } from 'react';
import Reducer from './Reducer';

const initialState = {
  user_data: {
    accessToken: '',
    userId: '',
    profilePicture: '',
    subscriptionExpiry: '',
    tokenExpiry: '',
    isSignup: false,
    firstName: '',
    lastName: '',
  },
  elearn_data: {
    activeCategory: '',
    activeCourse: '',
    activeTopic: '',
    activeLesson: '',
    activeInstructor: '',
  },
  user_subscription: {
    expiringOn: '',
    isSubscribed: false,
    planId: '',
    plan: '',
    price: '',
    orderId: '',
  },
  general: {
    session: '',
    prevPath: '/',
  },
  notification: {
    count: 0,
  },
};

const Store = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, initialState);
  
  // Memoize context value - dispatch from useReducer is stable and never changes
  // Only state changes will trigger re-renders
  const contextValue = useMemo(() => ({ 
    state, 
    dispatch 
  }), [state]);

  return (
    <Context.Provider value={contextValue}>{children}</Context.Provider>
  );
};

export const Context = createContext(initialState);

export default Store;
